// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aqP9FqumyLvTg5 {
  display: flex;
  position: relative;
  flex-grow: 0;
  flex-wrap: wrap;
  align-items: center;
  align-items: flex-start;
  justify-content: space-between;
  padding: var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-0, 0);
  row-gap: var(--ds-space-0, 0);
}
.aqP9FqumyLvTg5.NpmaLqgUsGI1wd {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: revert;
  padding: var(--ds-space-100, 8px) var(--ds-space-050, 4px) var(--ds-space-200, 16px);
  overflow: hidden;
  border-radius: inherit;
  cursor: pointer;
  writing-mode: vertical-lr;
}
.aqP9FqumyLvTg5.NpmaLqgUsGI1wd:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.aqP9FqumyLvTg5.NpmaLqgUsGI1wd:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.firefox .aqP9FqumyLvTg5.NpmaLqgUsGI1wd,
.safari .aqP9FqumyLvTg5.NpmaLqgUsGI1wd {
  width: var(--ds-space-500, 40px);
  padding-right: var(--ds-space-0, 0);
  padding-left: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var listHeader = `aqP9FqumyLvTg5`;
export var collapsed = `NpmaLqgUsGI1wd`;
export default ___CSS_LOADER_EXPORT___;
